import React, { PropTypes } from 'react';
import axios from '../../../../constants/axios';
import { IndexLink, Link } from 'react-router';
import { Button } from 'react-bootstrap';

class ExpenseInvoiceDetail extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         invoiceDetails: {}
      };
   }


   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`expenses/getInvoiceDetailsById/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceDetails: res.data
            });
         });
   }

   render() {
      const { invoiceDetails } = this.state;
      return (
         <div className="ExpenseInvoiceDetail" >
            <h1 >Expense Invoice Detail</h1 >
            <div className="row" >
               <div className="col-md-6" >
                  <p >InvoiceId: {invoiceDetails.id}</p >
                  <p className="text-success" >Vendor Name: {invoiceDetails.contact_name}</p >
                  <p >Amount: {invoiceDetails.total_amount}</p >
                  <p >Paid: {invoiceDetails.paid_amount}</p >
                  <p >Due: {invoiceDetails.due}</p >
                  <p >Memo: {invoiceDetails.memo}</p >
                  <p className="text-danger" >Invoice Created By: {invoiceDetails.invoice_created_by}</p >
                  <p >Date: {invoiceDetails.created_at}</p >
                  {invoiceDetails.due !== 0 &&
                  <Link to={`/expense/expensePayBill/${invoiceDetails.id}`} >
                     <Button block bsStyle="success" >Pay</Button >
                  </Link >
                  }
               </div >
               <div className="col-md-6" >
                  <address >
                     <pre >Address: {invoiceDetails.contact_address}</pre >
                     <pre >District: {invoiceDetails.district_name}</pre >
                     <pre >Thana: {invoiceDetails.thana_name}</pre >
                     <pre >Address Type: {invoiceDetails.contact_address_type_name}</pre >
                  </address >
               </div >
            </div >
            <div >
               <ul className="nav nav-tabs" >
                  <li >
                     <IndexLink to={`/expense/expenseInvoiceDetail/${invoiceDetails.id}`}
                                activeStyle={{ color: 'red' }} >Items</IndexLink >
                  </li >
                  <li >
                     <Link to={`/expense/expenseInvoiceDetail/${invoiceDetails.id}/paymentHistory`}
                           activeStyle={{ color: 'red' }} >Payment
                        History</Link >
                  </li >
               </ul >
            </div >
            {this.props.children}
         </div >
      );
   }
}

ExpenseInvoiceDetail.propTypes = {
   params: PropTypes.object,
   children: PropTypes.object
};


export default ExpenseInvoiceDetail;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Expense/ExepnseInvoiceDetail/ExpenseInvoiceDetail.js
 **/